export { default as DefaultPage } from './DefaultPage';
export { default as ServiceItem } from './ServiceItem';
export { default as CoachLayout } from './CoachLayout';
export { default as SelectedServiceMore } from './SelectedServiceMore';
export { default as PaymentDetailsPage } from './PaymentDetailsPage';
export { default as PaymentRightSideBar } from './PaymentRightSideBar';
export { default as TrainCoachLayout } from './TrainCoachLayout';



// WEBPACK FOOTER //
// ./src/features/pb-service-list/index.js